module.exports = __webpack_public_path__ + "img/三端@2x.565fcfbd.png";